"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FormInputControl = function (_Component) {
  (0, _inherits2["default"])(FormInputControl, _Component);

  var _super = _createSuper(FormInputControl);

  function FormInputControl(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, FormInputControl);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (e) {
      console.debug('%c[inputmultilang] [FormInputControl] [onChange()] begin...', 'color:blue');

      if (_this.props.onChange) {
        console.debug('%c[inputmultilang] [FormInputControl] [onChange()] this.props.onChange() will be invoked', 'color:blue');

        _this.props.onChange(e.target.value);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFocus", function (e) {
      console.debug('%c[inputmultilang] [FormInputControl] [onFocus()] begin...', 'color:blue');

      if (_this.props.onFocus) {
        console.debug('%c[inputmultilang] [FormInputControl] [onFocus()] this.props.onFocus() will be invoked', 'color:blue');

        _this.props.onFocus(e);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlur", function (e) {
      console.debug('%c[inputmultilang] [FormInputControl] [onBlur()] begin...', 'color:blue');

      if (_this.props.onBlur) {
        console.debug('%c[inputmultilang] [FormInputControl] [onBlur()] this.props.onBlur() will be invoked', 'color:blue');

        _this.props.onBlur(e.target.value);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClick", function (e) {
      _this.props.onClick && _this.props.onClick(e);
    });
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onFocus = _this.onFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onBlur = _this.onBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(FormInputControl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.focus) {
        this.focus();
        this.setSelectionRange();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.focus) {
        this.focus();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      var _self = this;

      if (_self._input) {
        if (_self._input) {
          console.debug('%c[inputmultilang] [FormInputControl] [focus()] _self._input.focus()', 'color:blue');

          _self._input.focus();
        }
      }
    }
  }, {
    key: "setSelectionRange",
    value: function setSelectionRange() {
      var _self = this;

      if (_self._input) {
        if (_self._input) {
          _self._input.setSelectionRange(0, this._input.value.length);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var classNames = 'wui-form-control wui-input multi-lang wui-input-affix-wrapper';

      if (this.props.className) {
        classNames += ' ' + this.props.className;
      }

      var _this$props = this.props,
          value = _this$props.value,
          placeholder = _this$props.placeholder;
      var inputProps = {};

      for (var propKey in this.props) {
        if (['onChange', 'onBlur', 'onClick'].indexOf(propKey) > -1) {
          continue;
        }

        inputProps[propKey] = this.props[propKey];
      }

      return _react["default"].createElement("input", (0, _extends2["default"])({}, inputProps, {
        placeholder: "",
        title: value || placeholder,
        ref: function ref(input) {
          _this2._input = input;
        },
        className: classNames,
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onClick: this.onClick
      }));
    }
  }]);
  return FormInputControl;
}(_react.Component);

var _default = FormInputControl;
exports["default"] = _default;
//# sourceMappingURL=FormInputControl.js.map